import styled from "styled-components";

export const UserBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  height: 100%;

  margin-right: 2rem;
`;
